import React from "react";
import styled from "styled-components";

const ButtonStyled = styled.a`
    height: 48px;
    text-wrap: nowrap;
    min-width: 165px;
    max-width: 165px;
    margin-left: 40px;
    font-weight: 700;
    font-size: 16px;
    line-height: 1;
    display: flex;
    align-items: center;
    padding: 15px 15px;
    border-radius: 4px;
    justify-content: center;
    cursor: pointer;
    background: var(--darkAlt);
    border-radius: 10px;
    color: var(--whiteColor);
    transition: transform 0.6s;

    @media only screen and (min-width: 768px) and (max-width: 1440px) and (max-height: 798px) {
        font-size: 15px;
    }

    @media only screen and (max-width: 1024px){
        min-width: 160px;
        max-width: 160px;
        margin-left: 24px;
        font-size: 14px;
    }

    @media only screen and (min-width: 768px) and (max-width: 1280px) and (max-height: 698px){
        font-size: 12.5px;
        min-width: 136px;
        height: 39px;
     }

    @media only screen and (max-width: 991px){
        font-size: 13px;
        min-width: 192px;
        max-width: 192px;
    }
`;
export const K4bHeaderButton = React.memo((props) => {
    return (
        <ButtonStyled
            href="https://kudabusiness.onelink.me/epwz/jceed731/"
            target="_blank"
            rel="noopener noreferrer" className={props.isMobile ? 'mr-3 ml-0' : null}>
            Open an Account
        </ButtonStyled>
    )
})